import toast from 'react-hot-toast';
import { takeEvery, put, call, select } from 'redux-saga/effects';
import * as photoSetApi from '../../api/photoSetApi';
import * as actions from '../actions';
import * as selectors from '../selectors';

export function* addPhotoSet({ payload: { set } }) {
  try {
    yield call(photoSetApi.add, set);
    yield put(actions.photoSets.addPhotoSetSuccess());
    toast.success('Photo added.');
  } catch (e) {
    yield put(actions.photoSets.addPhotoSetFail());
    toast.error('An error occurred adding the photoset. Make sure the photoset name has not been used before.');
  }
}
export function* updatePhotoSet({ payload: { set } }) {
  try {
    yield call(photoSetApi.update, set);
    yield put(actions.photoSets.updatePhotoSetSuccess());
    toast.success('Photo updated.');
  } catch (e) {
    yield put(actions.photoSets.updatePhotoSetFail());
    toast.error('An error occurred updating the photoset.');
  }
}
export function* getPhotoSets({ payload: { query } }) {
  try {
    yield put(actions.user.setLoading(true));
    const take = 50;
    const page = yield select(selectors.photoSets.page);
    const { photos, count } = yield call(photoSetApi.get, { ...query, page: page - 1, take });
    yield put(actions.photoSets.getPhotoSetsSuccess(photos));
    yield put(actions.photoSets.setPhotoSetCount(count));
  } catch (e) {
    yield put(actions.photoSets.getPhotoSetsFail());
    toast.error('An error occurred retrieving the photoset.');
  } finally {
    yield put(actions.user.setLoading(false));
  }
}

export function* getPhotoSetById({ payload: { id } }) {
  try {
    const photo = yield call(photoSetApi.getById, id);
    yield put(actions.photoSets.getPhotoSetByIdSuccess(photo));
  } catch (e) {
    yield put(actions.photoSets.getPhotoSetByIdFail());
    toast.error('An error occurred retrieving the photoset.');
  }
}

export function* searchPhotoSets({ payload: { query } }) {
  try {
    yield put(actions.user.setLoading(true));
    const take = 50;
    const page = yield select(selectors.photoSets.page);
    const { photos, count } = yield call(photoSetApi.search, { ...query, page: page - 1, take });
    yield put(actions.photoSets.setPhotoSetCount(count));
    yield put(actions.photoSets.searchPhotoSetsSuccess(photos));
  } catch (e) {
    yield put(actions.photoSets.searchPhotoSetsFail());
    toast.error('An error occurred retrieving the photoset.');
  } finally {
    yield put(actions.user.setLoading(false));
  }
}

export function* photoSetSagas() {
  yield takeEvery(actions.photoSets.addPhotoSet, addPhotoSet);
  yield takeEvery(actions.photoSets.updatePhotoSet, updatePhotoSet);
  yield takeEvery(actions.photoSets.getPhotoSets, getPhotoSets);
  yield takeEvery(actions.photoSets.getPhotoSetById, getPhotoSetById);
  yield takeEvery(actions.photoSets.searchPhotoSets, searchPhotoSets);
}
